module.exports = __webpack_public_path__ + "static/media/error.7b7ac30d.png";